module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "invoice",
    attrs: {
      "id": 'invoice' + _vm.invoice.meta.key
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("INVOICE "), _c('span', {
    staticStyle: {
      "color": "#bbb"
    }
  }, [_vm._v(_vm._s(_vm.getInvoiceId(_vm.invoice)))])]), _vm._v(" "), _c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.invoice.to.firstName) + " " + _vm._s(_vm.invoice.to.lastName) + " (invoice date " + _vm._s(_vm.invoiceDate) + ")"), _c('br'), _vm._v("\n                " + _vm._s(_vm.invoice.to.entity) + "\n            ")])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.invoice.from.entity || _vm.invoice.from.firstName + ' ' + _vm.invoice.from.lastName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.invoice.from.address) + " "), _c('b', [_vm._v("Ph")]), _vm._v(" " + _vm._s(_vm.invoice.from.mobile) + "\n            ")])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v(_vm._s(_vm.invoice.from.abn))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_vm._v(_vm._s(_vm.invoice.from.account))])])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, _vm._l((_vm.invoice.charges), function(charge) {
    return _c('tr', {
      key: charge.meta.key
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm._f("date")(charge.date)) + "\n            ")]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('td', _vm._g({
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.formatStamp(charge.stamp)
            }
          }, on), [_vm._v("\n                    " + _vm._s(charge.clients) + "\n                    ")])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteCharge(charge)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Charge")])], 1), _vm._v(" "), (_vm.isAdministrator) ? _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.debugCharge(charge)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Debug Charge")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(charge.description) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(charge.brokerName) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                " + _vm._s(charge.amount) + "\n            ")])])
  }), 0), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px",
      "width": "99%"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.invoice.total)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px"
    }
  }, [_vm._v("+GST: ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("cents")((_vm.invoice.total * 0.1))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding": "3px"
    }
  }, [_vm._v("Amount Payable:")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm._f("cents")((_vm.invoice.total * 1.1))))])])])]), _vm._v(" "), _c('small', [_vm._v("* Direct debit is on the " + _vm._s(_vm.nth) + " of each month. Manual payments due by the 15th. Invoice email: " + _vm._s(_vm.invoice.to.email) + " DDR: " + _vm._s(_vm.invoice.to.directDebitRef || '[none]'))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "valign": "top",
      "align": "right"
    }
  }, [_c('b', [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "valign": "top",
      "align": "right"
    }
  }, [_c('b', [_vm._v("From:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("ABN:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "padding": "3px"
    },
    attrs: {
      "align": "right"
    }
  }, [_c('b', [_vm._v("Account:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bd75444"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Billing/Invoice.vue
// module id = 2627
// module chunks = 1